const lang = {
    en: {
        settingsTitle: 'Settings',
        todoInputPlaceHolder: 'Type a name of todo here...',
        clear: 'Clear',
        clearAll: 'Clear All',
        addTodo: 'Add todo',
        yes: 'Yes',
        no: 'No',
        modal: {
            text: 'Are you sure?',
            title: 'If you confirm this action, todo list will be completely deleted'
        },
        back: 'Back',
        settings: {
            info: "Don't clear the localStorage of application in developer tools, otherwise your todo list will be completely deleted",
            selectLanguage: 'Select language:',
            selectLangPlaceholder: 'Language',
            selectTheme: 'Select color of theme:',
            selectThemePlaceholder: 'Color'
        },
        noOptions: 'No options'
    },
    uk: {
        settingsTitle: 'Налаштування',
        todoInputPlaceHolder: 'Введіть назву завдання тут...',
        clear: 'Видалити',
        clearAll: 'Видалити Всі',
        addTodo: 'Додати завдання',
        yes: 'Так',
        no: 'Ні',
        modal: {
            text: 'Ви впевнені?',
            title: 'Якщо ви підтвердите цю дію, список задач буде повністю видалено'
        },
        back: 'Назад',
        settings: {
            info: 'Не видаляйте localStorage додатку у панелі розробника, інакше ваш список задач буде повністю видалено',
            selectLanguage: 'Оберіть мову:',
            selectLangPlaceholder: 'Мова',
            selectTheme: 'Оберіть колір теми',
            selectThemePlaceholder: 'Колір'
        },
        noOptions: 'Немає варіантів'
    }
}

export default lang;